<!-- @format -->

<!-- ACCOUNT / CLIENT / BRANCH INFO (outside card) -->
<div class="context-info">
	<span *ngIf="currentRole === Roles.superAdmin"
		>Account: {{ selectedValues['company'].companyName }} &nbsp;|&nbsp;
	</span>
	Client: {{ selectedValues['plant'].plantName }} &nbsp;|&nbsp; Branch:
	{{ selectedValues['unit'].unitName }}
</div>

<div class="card custom-section">
	<div class="section-header">
		<div>
			<h1 class="section-title">Edit Form Field</h1>
			<p class="subtext">Fill out the form field details using the form below.</p>
		</div>
	</div>

	<form
		#form="ngForm"
		style="margin-top: 2rem"
		(ngSubmit)="activateSubmitBtn() && (showModal = true)">

		<!-- DATA POINT NAME -->
		<div class="form-group col-1">
			<div>
				<label
					for="data_point_name"
					class="custom-label required"
					>Form Field Name</label
				>
				<input
					type="text"
					class="custom-input"
					name="data_point_name"
					id="data_point_name"
					[(ngModel)]="editDataPointRequest.dataPointName" />
			</div>
		</div>

		<!-- DATA TYPE -->
		<div class="form-group col-1">
			<div>
				<label
					for="unit"
					class="custom-label required"
					>Form Field Type</label
				>
				<app-dropdown
					[disabled]="true"
					selectedItem="{{ editDataPointRequest.dataType }}"
					label="{{ editDataPointRequest.dataType }}"></app-dropdown>
			</div>
		</div>

		<!-- UNIT OF MEASUREMENT -->
		<div class="form-group col-1" *ngIf="editDataPointRequest.dataType === 'Number'">
			<div>
				<label
					for="unit"
					class="custom-label required"
					>Unit of Measurement</label
				>
				<input
					type="text"
					class="custom-input"
					placeholder="Enter unit of measurement"
					name="unit"
					id="unit"
					[(ngModel)]="editDataPointRequest.unitOfMeasurement" />
			</div>
		</div>

		<!-- LIST OPTIONS -->
		<div
			class="form-group col-1 options-section"
			*ngIf="
				editDataPointRequest.dataType === 'List (Single Selection)' ||
				editDataPointRequest.dataType === 'List (Multiple Selection)' ||
				editDataPointRequest.dataType === 'Dropdown List'
			"
		>
			<div>
				<label class="custom-label">Options</label>
				<div
					class="option-row"
					[class.option-highlight]="highlightEmptyOption && optionsList[i].trim() === ''"
					*ngFor="let option of optionsList; let i = index; trackBy: trackByIndex"
				>
					<input
						type="text"
						class="custom-input"
						placeholder="Enter option"
						[ngModel]="optionsList[i]"
						(ngModelChange)="optionsList[i] = $event; onOptionChange()"
						[name]="'option_' + i"
					/>
					<button
						type="button"
						class="btn-remove-option"
						*ngIf="optionsList.length > 1"
						(click)="removeOption(i)"
					>
						&times;
					</button>
				</div>
				<button
					type="button"
					class="btn-add-option"
					(click)="addOption()"
				>
					+ Add option
				</button>
				<div *ngIf="validationErrorMessage" class="error">
					<img src="../../assets/alert.svg" alt="" />
					<p>{{ validationErrorMessage }}</p>
				</div>
			</div>
		</div>

		<!-- MIN / MAX -->
		<div
			class="form-group col-2"
			*ngIf="editDataPointRequest.dataType === 'Number'">
			<div>
				<label
					for="data_point_min"
					class="custom-label required"
					>Form Field Min</label
				>
				<input
					type="text"
					class="custom-input"
					name="data_point_min"
					placeholder="Enter min"
					id="data_point_min"
					[(ngModel)]="editDataPointRequest.dataPointMin" />
			</div>
			<div>
				<label
					for="data_point_max"
					class="custom-label required"
					>Form Field Max</label
				>
				<input
					type="text"
					class="custom-input"
					name="data_point_max"
					id="data_point_max"
					placeholder="Enter max"
					[(ngModel)]="editDataPointRequest.dataPointMax" />
			</div>
		</div>

		<!-- DESCRIPTION -->
		<div class="form-group col-1">
			<div>
				<label
					for="desc"
					class="custom-label"
					>Description</label
				>
				<textarea
					name="desc"
					id="desc"
					cols="30"
					rows="10"
					placeholder="Type here"
					class="custom-input"
					[(ngModel)]="editDataPointRequest.dataPointDescription">
				</textarea>
			</div>
		</div>

		<div
			*ngIf="!errorMessage.success"
			class="error">
			<img
				src="../../assets/alert.svg"
				alt="" />
			<p>{{ errorMessage.message }}</p>
		</div>

		<input
			type="hidden"
			name="company_is_deleted"
			id="company_is_deleted"
			[(ngModel)]="editDataPointRequest.isDeleted" />
		<div class="btn-group">
			<button
				(click)="transferData()"
				class="btn-outline"
				routerLink="../..">
				Cancel
			</button>
			<button
				type="submit"
				class="btn-fill"
				[disabled]="!activateSubmitBtn()"
				[ngClass]="!activateSubmitBtn() ? 'disabled-btn' : ''">
				Update Form Field
			</button>
		</div>
	</form>
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
<app-save-modal
	*ngIf="showModal"
	(closeModal)="closeModal()"
	(onSave)="editDataPoint()"></app-save-modal>
